import * as React from 'react'
import Layout from '../components/Layout'
import Section from '../components/Section'
import Navigation from '../components/Navigation'
import PrivacyPolicySection from '../components/PrivacyPolicySection'
import Footer from '../components/Footer'

const PrivacyPolicy: React.FC = () => (
  <Layout>
    <Section color="primary" clip={{ bottomRight: true }}>
      <Navigation />
    </Section>
    <Section color="white">
      <PrivacyPolicySection />
    </Section>
    <Section color="secondary" clip={{ topLeft: true }} glue>
      <Footer />
    </Section>
  </Layout>
)

export default PrivacyPolicy
